/* unplugin-vue-components disabled */import script from "./article.vue?vue&type=script&setup=true&lang=js"
export * from "./article.vue?vue&type=script&setup=true&lang=js"

import "./article.vue?vue&type=style&index=0&id=25d5c3af&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25d5c3af"]])

export default __exports__